import { render, staticRenderFns } from "./TopHeaderStrip.vue?vue&type=template&id=141c55fa&scoped=true&"
import script from "./TopHeaderStrip.vue?vue&type=script&lang=js&"
export * from "./TopHeaderStrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141c55fa",
  null
  
)

export default component.exports